module.exports = __webpack_public_path__ + "img/wall_items-sprite-1x.62a29fee.png";